import { toggleToast } from '../../toast/index.js';

var TOAST_OFFSET_TOP = 20;
var createFormToastToggler = function createFormToastToggler(formClass) {
  return function (msg) {
    return toggleToast(msg, ".".concat(formClass), TOAST_OFFSET_TOP);
  };
};

export { createFormToastToggler };
